import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogFooter,
  DialogTitle,
  DialogDescription,
} from '@app/components/ui/Dialog/Dialog'
import { Button } from '@/components/ui/button'
import { RiskWorkspace } from '@app/types'

type WorkspaceDeleteDialogProps = {
  workspace: RiskWorkspace | null
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
}

export const WorkspaceInformationDialog = ({
  workspace,
  open,
  onOpenChange,
  onConfirm,
}: WorkspaceDeleteDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent showCloseButton={false}>
        <DialogHeader>
          <DialogTitle>{workspace?.name}?</DialogTitle>
          <DialogDescription>Some information</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button onClick={() => onOpenChange(false)} variant="outline">
            Cancel
          </Button>
          <Button onClick={onConfirm} variant="default">
            Apply Workspace
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
